
















import { Component, Prop, Vue } from "vue-property-decorator";

const LISTA = [
  { pergunta: "Preciso entender alguma coisa sobre numerologia para aproveitar o treinamento?", resposta: "Não, não precisa. O treinamento é exatamente para não-numerólogos e vai ensinar qualquer pessoa a sair do zero."},
  { pergunta: "Terei acesso ao conteúdo só durante o período em que estiver fazendo o treinamento?", resposta: "Não, o conteúdo será liberado em uma plataforma em que você pode consultar os vídeos e o material a qualquer momento após a aquisição, por ATÉ DOIS ANOS."},
  { pergunta: "Será que funciona para mim?", resposta: "Sim. A Kimtara, com 12 anos de atendimento por meio da ciência da numerologia, tem a convicção que o método funciona para qualquer pessoa, já funcionou inclusive para diversas alunas formadas por meio do método dela. Mas é preciso dedicação para aprendê-lo. Não tem fórmulas mágicas nesse treinamento. A responsabilidade é sua em estudar e em executar o método."},
  { pergunta: "Eu não acredito em numerologia e não acredito que a numerologia possa resolver meus problemas pessoais. O que fazer?", resposta: "Ok. Tudo bem. É importante ressaltar que a numerologia é uma ciência e é usada, com métodos, em favor de milhares de pessoas a centenas de milhares de anos. Ela foi decodificada por Pitágoras, um filósofo e matemático que viveu seis séculos antes de Cristo. Só a Kimtara já atendeu mais de 2,5 mil clientes que tiveram resultado significativo na vida. A numerologia é um código de linguagem científico da nossa psiquê e a nossa vida melhora a partir do momento que aprendemos a falar esse “idioma”."},
  { pergunta: "Consigo assistir às aulas pelo computador e pelo celular?", resposta: "Sim. O treinamento on-line permite que o conteúdo possa ser acessado por celulares, tablets e computadores."}
];

@Component
export default class extends Vue {
  // @Prop() private msg!: string;
  itens: Array<Item> = [];

  // Lifecycle hook
  mounted() {
    let counter = 0;
    this.itens = LISTA.map(function(item) {
      counter++;
      return new Item(counter, item.pergunta, item.resposta);
    });
  }
}

class Item {
  numero: number;
  pergunta: string;
  resposta: string;
  constructor(numero: number, pergunta: string, resposta: string) {
    this.numero = numero;
    this.pergunta = pergunta;
    this.resposta = resposta;
  }
}
